import _classCallCheck from "/Users/itsdapi/Documents/Project/WebProjects/taro36-virtual-list/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/itsdapi/Documents/Project/WebProjects/taro36-virtual-list/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/Users/itsdapi/Documents/Project/WebProjects/taro36-virtual-list/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/Users/itsdapi/Documents/Project/WebProjects/taro36-virtual-list/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { Component } from 'react';
var App = /*#__PURE__*/function (_Component) {
  _inherits(App, _Component);
  function App() {
    _classCallCheck(this, App);
    return _callSuper(this, App, arguments);
  }
  _createClass(App, [{
    key: "render",
    value:
    // 在 App 类中的 render() 函数没有实际作用
    // 请勿修改此函数
    function render() {
      // eslint-disable-next-line react/prop-types
      return this.props.children;
    }
  }]);
  return App;
}(Component);
export default App;